import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import { CognitoUser } from "../redux/user/user-types";

// This is a replacement for the now-removed currentAuthenticatedUser function from aws-amplify.
// It has been removed in favour of getCurrentUser & fechAuthSession. This just replicates the
// combined functionality from the old method to ease migration: it gets both the user and the
// session and combines into a single object.
export async function currentAuthenticatedUser(): Promise<CognitoUser> {
  const [user, session] = await Promise.all([getCurrentUser(), fetchAuthSession()]);
  return {
    email: user.signInDetails!.loginId!,
    session,
  };
}
